import React from "react";
import UseCaseHeader from "components/UseCaseHeader";
import ServiceLogoGrid from "components/ServiceLogoGrid";
import { USE_CASES } from "utils/constants/useCases";
import IMAGES from "utils/constants/image";
import { EMAIL_SERVICES } from "utils/constants/useCases";
import { styles } from "./styles";
import CopyToClipboard from "components/CopyToClipboard";
import ExternalLink from "components/ExternalLink";
import { getShortLinkCheckoutUrl } from "utils/shortLink";
import { ENV } from "utils/constants/env";
import { isServer } from "utils/view";

const COPY_PRIMARY =
  "Email is a leading revenue generating channel for most companies and with payment links, this channel can have an even higher ROI.";

const COPY_SECONDARY =
  "Payment links can be pre-configured with discounts to incentivize sales and personalized to each customer through query string params.";

const Email = ({ shortLink }) => {
  const compatibleWith = (
    <div className="w-100 pt3" key="compatible-with">
      <div className="f6 black-50 pb2 pb0-l">Compatible with</div>
      <ServiceLogoGrid
        services={[
          EMAIL_SERVICES.MAILCHIMP,
          EMAIL_SERVICES.HUBSPOT,
          EMAIL_SERVICES.INTERCOM,
          EMAIL_SERVICES.SENDGRID,
          EMAIL_SERVICES.CONVERT_KIT,
          EMAIL_SERVICES.KLAVIYO
        ]}
      />
    </div>
  );

  const liveUrl =
    shortLink &&
    `${getShortLinkCheckoutUrl({
      id: shortLink.short_id,
      mode: ENV.PRODUCTION,
      test: true
    })}?customer_email=someone@email.com`;

  return (
    <div className="w-100">
      <div className="w-100 w-50-ns fl">
        <UseCaseHeader type={USE_CASES.EMAIL} />
        <div className="f5 f4-l tl lh-copy pt2 pt4-l">{COPY_PRIMARY}</div>
        <div className="dn dib-ns">
          <div className="f5 f4-l mb3 mt0-ns tl lh-copy pt2">
            {COPY_SECONDARY}
          </div>
          {compatibleWith}
        </div>
      </div>
      <div className="w-100 w-50-ns fr pt3 pt0-l">
        <div className={`${IMAGES.USE_CASE_EMAIL}--wrapper`}>
          <div className={`${IMAGES.USE_CASE_EMAIL}--img contain contain`} />
        </div>
        <div className="w-100 ph2" key="link-personalization">
          <div className="f6 black-50 pv2 tc">Link with personalization:</div>
          {!isServer() && liveUrl && (
            <div
              key="external"
              className="lh-copy word-break-all pv2 pr2 bg-content--secondary ba br2 hairline-1 w-100 flex flex-row"
            >
              <CopyToClipboard
                key="copy"
                tooltip="Copy link"
                toast="Copied link to clipboard"
                value={liveUrl}
              />
              <ExternalLink
                href={liveUrl}
                copy={liveUrl}
                customClasses={{
                  container: "w-100 db",
                  link:
                    "link flex flex-row items-center justify-between link__decoration--hover color-primary pointer w-100 word-break-all",
                  copy: "f6 lh-title pr2"
                }}
              />
            </div>
          )}
        </div>
        <div className="w-100 dn-ns dib">
          <div className="f5 f4-l mb3 mt3 mt0-ns tl lh-copy pt2">
            {COPY_SECONDARY}
          </div>
          {compatibleWith}
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};
export default Email;
